/* eslint-disable tailwindcss/no-arbitrary-value */
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography,
} from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React from 'react';
import { IBtApiState } from '../../../../models/purchase-history';
import { BuildertrendModalBody } from './BuildertrendModalBody';
import { BuildertrendModalFooter } from './BuildertrendModalFooter';

import '../../../../styles/buildertrend.scss';

export interface IBuildertrendModal {
  open: boolean;
  handleOpen: () => void;
  handleClose: () => void;
  userIsLinked: boolean;
  adminUnlinkRadio: 'customer' | 'user';
  setAdminUnlinkRadio: (value: 'customer' | 'user') => void;
  btApiState: IBtApiState;
  setBtApiState: (value: IBtApiState) => void;
}

const createModalHeaderText = (
  loggedInUserName: string,
  userIsLinked: boolean,
): string => {
  if (userIsLinked) {
    return 'Disconnect Buildertrend Account';
  }

  return `Welcome, ${loggedInUserName}`;
};

export const BuildertrendModal = ({
  open,
  handleClose,
  userIsLinked,
  adminUnlinkRadio,
  setAdminUnlinkRadio,
  btApiState,
  setBtApiState,
}: IBuildertrendModal) => {
  const { username } = useThdCustomer();

  const loggedInUserName = username || '';

  const BuildertrendModalBodyProps = {
    userIsLinked,
    adminUnlinkRadio,
    setAdminUnlinkRadio,
    btApiState,
    setBtApiState,
  };

  const BuildertrendModalFooterProps = {
    handleClose,
    userIsLinked,
    btApiState,
    setBtApiState,
    adminUnlinkRadio,
  };

  return (
    <Modal open={open} onClose={handleClose} size="md">
      <ModalHeader onClose={handleClose}>
        <Typography variant="h4">
          {createModalHeaderText(loggedInUserName, userIsLinked)}
        </Typography>
      </ModalHeader>
      <ModalBody>
        <BuildertrendModalBody {...BuildertrendModalBodyProps} />
      </ModalBody>
      <ModalFooter>
        <BuildertrendModalFooter {...BuildertrendModalFooterProps} />
      </ModalFooter>
    </Modal>
  );
};
